(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("polyglot"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "polyglot"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("polyglot")) : factory(root["underscore"], root["polyglot"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_17__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition